<template>
  <div>
    <b-table
      show-empty
      :busy="loading"
      :fields="tableDataFields"
      ref="tableData"
      :items="tableData"
      head-variant="light"
      hover
      class="bg-white"
    >
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div align="center">
          <img src="/image/static/img/nodata.png" />
          <p class="text-secondary mt-2">暂无数据！</p>
        </div>
      </template>
      <template v-slot:head(prjTagName)="data">{{$l('table_head_labelName') || '标签名称'}}</template>
      <template v-slot:head(prjTagType)="data">{{$l('table_head_labelType') || '标签类型'}}</template>
      <template v-slot:head(prjTagOwnerName)="data">{{$l('table_head_labelOwner') || '标签所属人'}}</template>
      <template v-slot:head(prjTagStatus)="data">{{$l('table_head_status') || '状态'}}</template>
      <template v-slot:head(operation)="data">{{$l('table_head_operation') || '操作'}}</template>
      <template v-slot:cell(operation)="data">
        <b-button-group>
          <b-button
            title="编辑"
            class="mr-1"
            v-if="allow('M')"
            variant="outline-secondary"
            size="sm"
            @click="fromLoad('edit',data.item.prjTagCode)"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            title="删除"
            v-if="allow('D')"
            variant="outline-danger"
            size="sm"
            @click="delRow(data.item.prjTagCode)"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>
        </b-button-group>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="35%"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {
    PageDetail: () => import("./components/detail"),
  },
  data() {
    return {
      tableDataFields: [
        {
          key: "prjTagName",
          label: "标签名称",
          tdClass: "align-middle",
        },
        {
          key: "prjTagType",
          label: "标签类型",
          tdClass: "align-middle",
        },
        {
          key: "prjTagOwnerName",
          label: "标签所属人",
          tdClass: "align-middle",
        },
        {
          key: "prjTagStatus",
          label: "状态",
          tdClass: "align-middle",
        },
        {
          key: "operation",
          label: "操作",
          tdClass: "align-middle",
        },
      ],
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 选中的数据
      multipleSelection: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      // 设置标题
      this.formOption.title = opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    delRow(val) {
      this.multipleSelection = [val];
      this.del();
    },
    del() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({
          showClose: true,
          message: "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否删除？").then((_) => {
        this.$api
          .prjTagDelApi({
            prjTagCodeList: this.multipleSelection.map((item) =>
              item.prjTagCode ? item.prjTagCode : item
            ),
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.$emit("submit");
          });
      });
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
  },
};
</script>
